const storeList = {
  path: 'storeList',
  component: resolve => require(['../../../../../../../pages/admin/merchant/dispose/shopkeeper/storeList'], resolve),
}

export default storeList